import Client from '@/client'

export default {
  list() {
    return Client.get(`applications/`);
  },
  retrieve(id) {
    return Client.get(`applications/${id}/`)
  },
}